import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import Navbar from './components/layout/Navbar';
import KeyboardEventHandler from "react-keyboard-event-handler";
import { toast } from 'react-toastify';
import { LinearProgress } from "@material-ui/core";

// import Welcome from './scenes/welcome/Welcome';
// import Playground from './scenes/playground/Playground';
// import ManualBook from "./scenes/manual-book/ManualBook";
// import About from "./scenes/about/About";

const Welcome = lazy(() => import('./scenes/welcome/Welcome'));
const Playground = lazy(() => import('./scenes/playground/Playground'));
const ManualBook = lazy(() => import('./scenes/manual-book/ManualBook'));
const About = lazy(() => import('./scenes/about/About'));

const App = (props) => {

    const keyHandler = () => {
        localStorage.removeItem("nemu-new");
        localStorage.removeItem("nemu-new-playground");
        localStorage.removeItem("nemu-new-manual-book");

        toast("Clear storage", {
            autoClose: 500,
        })
    };

    return (
        <BrowserRouter>
            <KeyboardEventHandler handleKeys={['f2']} onKeyEvent={keyHandler} />
            <Navbar />
            <ToastContainer />
            <Suspense fallback={<LinearProgress />}>
                <Switch>
                    <Route exact path="/" component={Welcome} />
                    <Route path="/playground" component={Playground} />
                    <Route path="/manual-book" component={ManualBook} />
                    <Route path="/about" component={About} />
                    <Redirect from='*' to='/' />
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
}

export default App;
